export const getChannelIdFromModelItem = (modelItem: any) =>
  modelItem?.channel?._id || modelItem?.channel?.id || modelItem?.channelId;
